<template>
    <header-layout />
    <content-layout />
</template>

<script>
    import HeaderLayout from "./parts/HeaderLayout";
    import ContentLayout from "./parts/ContentLayout";

    export default {
        name: 'LoginLayout',
        components: { HeaderLayout, ContentLayout },
        created() {
            document.body.classList.add('page-login');
        },
        unmounted() {
            document.body.classList.remove('page-login');
        }
    }
</script>
